<template>
  <section class="split-text">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container container--flex">
      <h1 class="split-text__head">we are driven by creating the best products and innovate on them so the world will be a better place.</h1>
      <p class="split-text__text">the history behind desperate. comes from three men who always wanted to corroborate with each other. we are all different profiles but knows that the best products comes from sparing and expertise from each others competencies.</p>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'SplitText',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SplitText/SplitText.vue